import { graphql } from '@/gql/graphql';
import { ChatMessageItemFragment } from './ChatMessageItem.utils';

export const ChatHomeListItemFragment = graphql(`
  fragment ChatHomeListItem on chat {
    id
    is_hidden
    unseen_message_count
    preference {
      chat_id
      person_id
      notification_preference
    }
    metadata
    chat_type
    messages(
      limit: 1
      order_by: { created_at: desc }
      where: { deleted_at: { _is_null: true } }
    ) {
      ...ChatMessageItem
    }
  }
`, [ChatMessageItemFragment]);
